import React from 'react';
import { Route } from 'react-router';

import Page from './component';

export default <Route
    exact
    key="auth"
    path="/auth"
    component={Page} />;